export const GET_PURCHASES_VERIFY = 'getPurchasesVerify'
export const GET_BEST_SELLING = 'getBestSelling'
export const GET_TOP_BUYERS = 'getTopBuyers'
export const GET_TOP_STORES = 'getTopStores'
export const GET_TOTAL_PAYMENT = 'getTotalPayment'
export const GET_WEEK_SALES = 'getWeekSales'